const doctorRoutes = [
  // 医生消息
  {
    path: 'doc-task',
    name: 'doc-task',
    meta: {
      title: '任务',
      requiresAuth: true,
      nav: false
    },
    component: resolve => require(['../views/page/doctor/doc-page-task.vue'], resolve)
  },
  // 病人信息
  {
    path: 'doc-patient-info',
    name: 'doc-patient-info',
    meta: {
      title: '病人信息',
      requiresAuth: true,
      nav: {
        title: '今日门诊',
        path: '/default/doc-detail-patient',
        children: null
      }
    },
    component: resolve => require(['../views/page/doctor/doc-patient-info.vue'], resolve)
  },
  // 全部病人
  {
    path: 'doc-all-patient',
    name: 'doc-all-patient',
    meta: {
      title: '全部病人',
      requiresAuth: true,
      nav: {
        title: '今日门诊',
        path: '/default/doc-detail-patient',
        children: null
      }
      // keepAlive: true
    },
    component: resolve => require(['../views/page/doctor/doc-all-patient.vue'], resolve)
  },
  // 接诊病人
  {
    path: 'doc-treatment-patient',
    name: 'doc-treatment-patient',
    meta: {
      title: '接诊病人',
      requiresAuth: true,
      nav: {
        title: '今日门诊',
        path: '/default/doc-detail-patient',
        children: null
      }
      // keepAlive: true
    },
    component: resolve => require(['../views/page/doctor/doc-treatment-patient.vue'], resolve)
  },
  // 新增验单
  {
    path: 'doc-add-inspection-sheet',
    name: 'doc-add-inspection-sheet',
    meta: {
      title: '新增验单',
      requiresAuth: true,
      nav: {
        title: '接诊病人',
        path: '/default/doc-treatment-patient',
        children: null
        // children: {
        //   title: '接诊病人',
        //   path: '/default/doc-treatment-patient'
        // }
      }
    },
    component: resolve => require(['../views/page/doctor/doc-add-inspection-sheet.vue'], resolve)
  },
  // 预约详情
  {
    path: 'doc-detail-patient',
    name: 'doc-detail-patient',
    meta: {
      title: '今日门诊',
      requiresAuth: true,
      nav: false
      // keepAlive: true
    },
    component: resolve => require(['../views/page/doctor/doc-detail-patient.vue'], resolve)
  },
  // 诊疗单
  {
    path: 'doc-add-curelist',
    name: 'doc-add-curelist',
    meta: {
      title: '新增治疗单',
      requiresAuth: true,
      nav: {
        title: '接诊病人',
        path: '/default/doc-treatment-patient',
        children: null
      }
      // keepAlive: true
    },
    component: resolve => require(['../views/page/doctor/doc-add-curelist.vue'], resolve)
  },
    // 我的排班
  {
    path: 'doc-my-schedule',
    name: 'doc-my-schedule',
    meta: {
      title: '我的排班',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/doctor/doc-my-schedule.vue'], resolve)
  },
  // 我的门诊
  {
    path: 'doc-my-clinic',
    name: 'doc-my-clinic',
    meta: {
      title: '我的门诊',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      },
      keepAlive: true
    },
    component: resolve => require(['../views/page/doctor/doc-my-clinic.vue'], resolve)
  },
  // 诊疗记录
  {
    path: 'doc-treatment-record',
    name: 'doc-treatment-record',
    meta: {
      title: '诊疗记录',
      requiresAuth: true,
      nav: {
        title: '接诊病人',
        path: '/default/doc-treatment-patient',
        children: null
      }
    },
    component: resolve => require(['../views/page/doctor/components/doc-treatment-record.vue'], resolve)
  },
  // 诊疗记录
  {
    path: 'doc-treatment-record-two',
    name: 'doc-treatment-record-two',
    meta: {
      title: '诊疗记录',
      requiresAuth: true,
      nav: {
        title: '工作站',
        path: '/default/workplace',
        children: null
      }
    },
    component: resolve => require(['../views/page/doctor/components/doc-treatment-record.vue'], resolve)
  },
  // 处方打印
  {
    path: 'doc-chufang-print',
    name: 'doc-chufang-print',
    meta: {
      title: '打印预览',
      requiresAuth: true,
      nav: {
        title: '接诊病人',
        path: '/default/doc-treatment-patient',
        children: null
      }
    },
    component: resolve => require(['../views/page/doctor/components/doc-chufang-print.vue'], resolve)
  }
]

export default doctorRoutes
